import { render, staticRenderFns } from "./onlineTopMsg.vue?vue&type=template&id=5ff7a910&scoped=true"
import script from "./onlineTopMsg.vue?vue&type=script&lang=ts"
export * from "./onlineTopMsg.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ff7a910",
  null
  
)

export default component.exports